import { render, staticRenderFns } from "./DealerGuide.vue?vue&type=template&id=664f4f8c&"
import script from "./DealerGuide.vue?vue&type=script&lang=js&"
export * from "./DealerGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports